import React, { useId } from 'react'
import PropTypes from 'prop-types'

const TrianglesIcon = React.forwardRef(function TrianglesIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M5.99999 9.98H18C18.38 9.98 18.73 9.77001 18.89 9.43001 19.05 9.09 19.02 8.69001 18.8 8.38L12.8.380005C12.42-.119995 11.58-.119995 11.2.380005L5.19999 8.38C4.96999 8.68001 4.93999 9.09 5.10999 9.43001 5.27999 9.77001 5.61999 9.98 5.99999 9.98ZM18 13.98H5.99999C5.61999 13.98 5.26999 14.19 5.10999 14.53 4.94999 14.87 4.97999 15.27 5.19999 15.58L11.2 23.58C11.39 23.83 11.68 23.98 12 23.98 12.32 23.98 12.61 23.83 12.8 23.58L18.8 15.58C19.03 15.28 19.06 14.87 18.89 14.53 18.72 14.19 18.38 13.98 18 13.98Z"></path>
    </svg>
  )
})

TrianglesIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

TrianglesIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default TrianglesIcon
